module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cd-Db-Ec-Fb-Gb.78d9ca5c.png";